import { render, staticRenderFns } from "./registrationManagement.vue?vue&type=template&id=6ced57fd&scoped=true"
import script from "./registrationManagement.vue?vue&type=script&lang=js"
export * from "./registrationManagement.vue?vue&type=script&lang=js"
import style0 from "./registrationManagement.vue?vue&type=style&index=0&id=6ced57fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced57fd",
  null
  
)

export default component.exports